export const productDetailsDisplayMode = {
    buyable: 1,
    presentation: 2,
};